import { useParams } from 'react-router-dom'
import PageBuilderForm from './PageBuilderForm'

const PageBuilder = () => {
    const params = useParams()

    return <PageBuilderForm id={params.pageId || null} />
}

export default PageBuilder
